import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { CloseIcon } from "../../Shared/Components/SvgIcons"
import Button from "../../Shared/Primitive/Button"
import { setModalData } from "../../Shared/SharedSlices/ModalSlice"
import { RootState } from "../../../App/store"
import { EditorModifier, RoleType, StorageKey } from "../../../App/enums"
import TextInput from "../../Shared/Primitive/TextInput"
import Checkbox from "../../Shared/Primitive/Checkbox"
import CharacterCounter from "../../Shared/Components/CharacterCounter"
import React, { useEffect, useMemo, useRef } from "react"
import EditorTextArea from "../../Shared/Components/Editor/EditorTextArea"
import { Editor as TinyMCEEditor } from "tinymce"
import { htmlRegex } from "../../../App/Regex"
import SingleTextInput from "../../Shared/Components/SingleTextInput"
import HashtagInput from "../../Shared/Components/HashtagInput"
import SessionService from "../../../App/SessionService"
import { roomPostPostRequest } from "../RoomPost/RoomPostRequests"
// Wizard replaces tabs; keep components simple conditional rendering
import { createEventRequest, updateEventRequest } from "../RoomServiceRequests/EventServiceRequest"
import { setRoomEventsData } from "../RoomSlices/RoomEventsSlice"
import Dropdown from "../../Shared/Primitive/Dropdown"
import { formatDate } from "../../../App/Helpers/Helpers"
import { setRoomData } from "../../Shared/SharedSlices/RoomSlice"
import Image from "../../Shared/Primitive/Image"

function RoomCreateEventModal(props: {
    createEvent?: boolean,
    editEvent?: boolean
}) {
    const isValidUrl = (value: string) => /^https?:\/\/.+\..+/.test(value)
    const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    const formatLocalDateTimeForApi = (date: Date | null) => {
        if (!date) {
            return ""
        }

        const year = date.getFullYear()
        const month = `${date.getMonth() + 1}`.padStart(2, "0")
        const day = `${date.getDate()}`.padStart(2, "0")
        const hours = `${date.getHours()}`.padStart(2, "0")
        const minutes = `${date.getMinutes()}`.padStart(2, "0")

        return `${year}-${month}-${day}T${hours}:${minutes}`
    }

    const parseApiDateTimeToLocalDate = (value?: string | null) => {
        if (!value) {
            return null
        }

        const parsedDate = new Date(value)
        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
    }

    const roomDataState = useSelector((state: RootState) => state.roomSlice.roomSlice.room)
    const organizationDataState = useSelector((state: RootState) => state.organizationsSlice.organizationSlice.organization)
    const userDataState = useSelector((state: RootState) => state.userDataSlice)
    const posts = useSelector((state: RootState) => state.RoomPostsSlice.roomPostsSlice.posts)

    const [name, setName] = React.useState("")
    const [description, setDescription] = React.useState("")
    const [fileselected, setFileSelected] = React.useState(false)
    const [file, setFile] = React.useState<any>(null)
    const [imagePreviewUrl, setImagePreviewUrl] = React.useState("")
    const [imagePositionX, setImagePositionX] = React.useState(50)
    const [imagePositionY, setImagePositionY] = React.useState(50)

    const [formatId, setFormatId] = React.useState<number>(0)
    const [locationTypeId, setLocationTypeId] = React.useState<number>(0)
    const [admission, setAdmission] = React.useState("")
    const [registrationLink, setRegistrationLink] = React.useState("")
    const [accessLink, setAccessLink] = React.useState("")
    const [mail, setMail] = React.useState("")
    const [website, setWebsite] = React.useState("")
    const [beginDate, setBeginDate] = React.useState<Date | null>(null)
    const [endDate, setEndDate] = React.useState<Date | null>(null)
    const [keywords, setKeywords] = React.useState<string[]>([])
    const [locationDetails, setLocationDetails] = React.useState("")

    const roomId = roomDataState.id
    const translation = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const roomEventsState = useSelector((state: RootState) => state.roomEventsSlice)


    const [notificationText, setNotificationText] = React.useState("")
    const [descriptionError, setDescriptionError] = React.useState("")
    const [nameError, setNameError] = React.useState("")
    const [startDateError, setStartDateError] = React.useState("")
    const [endDateError, setEndDateError] = React.useState("")
    const [keywordsError, setKeywordsError] = React.useState("")
    const [admissionError, setAdmissionError] = React.useState("")
    const [websiteError, setWebsiteError] = React.useState("")
    const [accessLinkError, setAccessLinkError] = React.useState("")
    const [registrationLinkError, setRegistrationLinkError] = React.useState("")
    const [locationTypeError, setLocationTypeError] = React.useState("")
    const [locationDetailsError, setLocationDetailsError] = React.useState("")
    const [formatError, setFormatError] = React.useState("")
    const [mailError, setMailError] = React.useState("")
    const editorRef = useRef<TinyMCEEditor | null>(null)
    const editorRef2 = useRef<TinyMCEEditor | null>(null)
    const imagePositionPreviewRef = useRef<HTMLDivElement | null>(null)
    const imageDragStateRef = useRef<{ pointerId: number, startX: number, startY: number, startPositionX: number, startPositionY: number } | null>(null)
    const textWithoutHtml = description?.replaceAll(htmlRegex, "")
    const [isSubmitting, setIsSubmitting] = React.useState(false)
    const [serverError, setServerError] = React.useState("")
    const [sendNotification, setSendNotification] = React.useState(false)
    const [isPositioningImage, setIsPositioningImage] = React.useState(false)
    const [currentStep, setCurrentStep] = React.useState<number>(0)
    const totalSteps = 3
    const stepTitles = ["Grunddaten", "Termin & Teilnahme", "Darstellung & Veröffentlichung"]
    const goNext = () => {
        if (currentStep < totalSteps - 1 && validateForm(currentStep)) {
            setCurrentStep(currentStep + 1)
        }
    }
    const goBack = () => { if (currentStep > 0) setCurrentStep(currentStep - 1) }
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const orgId = SessionService.getItem(StorageKey.organizationId)

    const locationTypes = useMemo(() => ([
        { id: 1, name: "Online" },
        { id: 2, name: "Hybrid" },
        { id: 3, name: "Vor Ort" }
    ]), [])

    const formats = useMemo(() => ([
        { id: 1, name: "Abstimmungsgespräch" },
        { id: 2, name: "Ausstellung" },
        { id: 3, name: "Bar-Camps" },
        { id: 4, name: "Community Call" },
        { id: 5, name: "Fachtagung" },
        { id: 6, name: "Festival" },
        { id: 7, name: "Fortbildung" },
        { id: 8, name: "Hackathon" },
        { id: 9, name: "Infoveranstaltung" },
        { id: 10, name: "Konferenzen" },
        { id: 11, name: "Kongress" },
        { id: 12, name: "Meet-Ups" },
        { id: 13, name: "Messen" },
        { id: 14, name: "Podiumsdiskussion" },
        { id: 15, name: "Sonstiges" },
        { id: 16, name: "Tag der offenen Tür" },
        { id: 17, name: "Webinare" },
        { id: 18, name: "Workshops" },
        { id: 19, name: "Peer-to-Peer Learning" }
    ].sort((a, b) => a.name.localeCompare(b.name, 'de'))), [])

    useEffect(() => {
        if (props.editEvent && roomEventsState.selectedItem) {
            setName(roomEventsState.selectedItem.title)
            setDescription(roomEventsState.selectedItem.description)
            editorRef.current?.setContent(roomEventsState.selectedItem.description);
            setAdmission(roomEventsState.selectedItem.admission)
            setRegistrationLink(roomEventsState.selectedItem.registration_link)
            setAccessLink(roomEventsState.selectedItem.access_link)
            setMail(roomEventsState.selectedItem.mail)
            setWebsite(roomEventsState.selectedItem.website)
            setKeywords(roomEventsState.selectedItem.keywords)
            setFormatId(roomEventsState.selectedItem.formats ? formats.find((format) => format.name === roomEventsState.selectedItem?.formats)?.id || 0 : 0)
            setLocationTypeId(locationTypes.find((locationType) => locationType.name === roomEventsState.selectedItem?.location_type)?.id || 0)
            setLocationDetails(roomEventsState.selectedItem.location_details)
            setImagePreviewUrl(roomEventsState.selectedItem.image || "")
            setImagePositionX(roomEventsState.selectedItem.image_position_x ?? 50)
            setImagePositionY(roomEventsState.selectedItem.image_position_y ?? 50)

            const startDate = parseApiDateTimeToLocalDate(roomEventsState.selectedItem.start_date)
            const endDate = parseApiDateTimeToLocalDate(roomEventsState.selectedItem.end_date)

            setBeginDate(startDate)
            setEndDate(endDate)
        }
    }, [props.editEvent, roomEventsState.selectedItem, formats, locationTypes])

    useEffect(() => {
        if (role === RoleType.ORGANIZATION && orgId) {
            editorRef2.current?.setContent(
                `${organizationDataState.name}</a> hat das Event "<a href='/e/${roomId}/#EID#'>${name}</a>" im Eventkalender dieses Raumes für den ${formatDate(beginDate!, 'dd.MM.yyyy')} veröffentlicht.`
            )
        } else if (role === RoleType.USER) {
            editorRef2.current?.setContent(`${userDataState.first_name}  ${userDataState.last_name} hat das Event "<a href='/e/${roomId}/#EID#'>${name}</a>" im Eventkalender dieses Raumes für den ${beginDate?.toLocaleDateString()} veröffentlicht.`)
        }
    }, [name, beginDate, orgId, organizationDataState.name, role, roomId, userDataState.first_name, userDataState.last_name])

    useEffect(() => {
        if (nameError && name.trim().length > 0) {
            setNameError("")
        }

        if (keywordsError && keywords.length > 0) {
            setKeywordsError("")
        }

        if (descriptionError) {
            const plainTextDescription = description?.replaceAll(htmlRegex, "").trim() || ""
            if (plainTextDescription.length > 0 && plainTextDescription.length <= 1000) {
                setDescriptionError("")
            }
        }

        if (formatError && formatId !== 0) {
            setFormatError("")
        }

        if (locationTypeError && locationTypeId !== 0) {
            setLocationTypeError("")
        }

        if (startDateError && beginDate) {
            setStartDateError("")
        }

        if (endDateError && beginDate && endDate && endDate > beginDate) {
            setEndDateError("")
        }

        if (registrationLinkError && registrationLink && isValidUrl(registrationLink)) {
            setRegistrationLinkError("")
        }

        if (accessLinkError && accessLink && isValidUrl(accessLink)) {
            setAccessLinkError("")
        }

        if (locationDetailsError && locationDetails.trim().length > 0) {
            setLocationDetailsError("")
        }

        if (mailError && mail && isValidEmail(mail)) {
            setMailError("")
        }

        if (websiteError && website && isValidUrl(website)) {
            setWebsiteError("")
        }
    }, [
        accessLink,
        accessLinkError,
        beginDate,
        description,
        descriptionError,
        endDate,
        endDateError,
        formatError,
        formatId,
        locationDetails,
        locationDetailsError,
        locationTypeError,
        locationTypeId,
        mail,
        mailError,
        name,
        nameError,
        registrationLink,
        registrationLinkError,
        startDateError,
        website,
        websiteError,
        keywords,
        keywordsError,
    ])

    // Validation logic extracted to a separate function
    function validateForm(stepToValidate?: number) {
        let hasError = false;

        // Reset errors
        setNameError("");
        setDescriptionError("");
        setStartDateError("");
        setEndDateError("");
        setKeywordsError("");
        setAdmissionError("");
        setWebsiteError("");
        setAccessLinkError("");
        setRegistrationLinkError("");
        setLocationTypeError("");
        setLocationDetailsError("");
        setFormatError("");
        setMailError("");
        setServerError("");

        if (stepToValidate === undefined || stepToValidate === 0) {
            if (name.trim().length === 0) {
                setNameError("Dieses Feld ist ein Pflichtfeld.");
                hasError = true;
            }

            if (!description || description.replaceAll(htmlRegex, "").trim().length === 0) {
                setDescriptionError("Dieses Feld ist ein Pflichtfeld.");
                hasError = true;
            } else if (description.replaceAll(htmlRegex, "").length > 1000) {
                setDescriptionError("Maximal 1000 Zeichen erlaubt.");
                hasError = true;
            }

            if (formatId === 0) {
                setFormatError("Dieses Feld ist ein Pflichtfeld.");
                hasError = true;
            }
        }

        if (stepToValidate === undefined || stepToValidate === 1) {
            if (locationTypeId === 0) {
                setLocationTypeError("Dieses Feld ist ein Pflichtfeld.");
                hasError = true;
            }

            if (!beginDate) {
                setStartDateError("Dieses Feld ist ein Pflichtfeld.");
                hasError = true;
            }
            if (!endDate) {
                setEndDateError("Dieses Feld ist ein Pflichtfeld.");
                hasError = true;
            }
            if (beginDate && endDate && endDate <= beginDate) {
                setEndDateError("Das Ende deiner Veranstaltung kann nicht vor dem Anfang liegen.");
                hasError = true;
            }

            if ((locationTypeId === 1 || locationTypeId === 2) && registrationLink === "" && accessLink === "") {
                setRegistrationLinkError("Bitte ergänze noch einen Anmelde- oder Zugangslink, damit die Teilnehmenden zu deiner Veranstaltung finden.");
                setAccessLinkError("Bitte ergänze noch einen Anmelde- oder Zugangslink, damit die Teilnehmenden zu deiner Veranstaltung finden.");
                hasError = true;
            }

            if (registrationLink !== "" && !isValidUrl(registrationLink)) {
                setRegistrationLinkError("Bitte eine gültige URL für den Anmelde-Link eingeben (inkl. http(s)://).");
                hasError = true;
            }
            if (accessLink !== "" && !isValidUrl(accessLink)) {
                setAccessLinkError("Bitte eine gültige URL für den Zugangslink eingeben (inkl. http(s)://).");
                hasError = true;
            }

            if ((locationTypeId === 2 || locationTypeId === 3) && !locationDetails && !registrationLink) {
                setLocationDetailsError("Bitte ergänze noch einen Anmeldelink oder Veranstaltungsort, damit die Teilnehmenden zu deiner Veranstaltung finden.");
                setRegistrationLinkError("Bitte ergänze noch einen Anmeldelink oder Veranstaltungsort, damit die Teilnehmenden zu deiner Veranstaltung finden.");
                hasError = true;
            }

            if (locationTypeId === 3 && !locationDetails) {
                setLocationDetailsError("Bitte ergänze noch einen Veranstaltungsort, damit die Teilnehmenden zu deiner Veranstaltung finden.");
                hasError = true;
            }
        }

        if (stepToValidate === undefined || stepToValidate === 2) {
            if (mail && !isValidEmail(mail)) {
                setMailError("Bitte eine gültige E-Mail-Adresse eingeben.");
                hasError = true;
            }

            if (website && !isValidUrl(website)) {
                setWebsiteError("Bitte eine gültige Website-URL eingeben (inkl. http(s)://).");
                hasError = true;
            }
        }

        if (hasError) {
            setServerError("Bitte die markierten Felder überprüfen.")
        }

        return !hasError;
    };

    const getApiErrorMessage = (error: any) => {
        const detail = error?.response?.data?.detail;

        if (Array.isArray(detail) && detail.length > 0) {
            return detail[0];
        }

        if (typeof detail === "string" && detail.trim().length > 0) {
            return detail;
        }

        if (typeof error?.response?.data === "string" && error.response.data.trim().length > 0) {
            return error.response.data;
        }

        return "Ein unerwarteter Fehler ist aufgetreten.";
    }

    const selectImage = (selectedFile: File) => {
        if (!selectedFile.type.startsWith("image/")) {
            setServerError("Bitte nur Bilddateien hochladen.")
            return
        }

        setServerError("")
        setFileSelected(true)
        setFile(selectedFile)

        const reader = new FileReader()
        reader.addEventListener("load", () => setImagePreviewUrl(String(reader.result || "")))
        reader.readAsDataURL(selectedFile)
    }

    const onImagePositionPointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
        imageDragStateRef.current = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            startPositionX: imagePositionX,
            startPositionY: imagePositionY,
        }
        event.currentTarget.setPointerCapture(event.pointerId)
        setIsPositioningImage(true)
    }

    const onImagePositionPointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
        const dragState = imageDragStateRef.current
        const previewWidth = imagePositionPreviewRef.current?.clientWidth
        const previewHeight = imagePositionPreviewRef.current?.clientHeight
        if (!dragState || dragState.pointerId !== event.pointerId || !previewWidth || !previewHeight) {
            return
        }

        const dragDistanceX = event.clientX - dragState.startX
        const dragDistanceY = event.clientY - dragState.startY
        const nextPositionX = dragState.startPositionX - (dragDistanceX / previewWidth) * 100
        const nextPositionY = dragState.startPositionY - (dragDistanceY / previewHeight) * 100
        setImagePositionX(Math.round(Math.min(100, Math.max(0, nextPositionX))))
        setImagePositionY(Math.round(Math.min(100, Math.max(0, nextPositionY))))
    }

    const stopImagePositioning = (event: React.PointerEvent<HTMLDivElement>) => {
        if (imageDragStateRef.current?.pointerId === event.pointerId) {
            imageDragStateRef.current = null
            setIsPositioningImage(false)
        }
    }

    const onImagePositionKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (!["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key)) {
            return
        }

        event.preventDefault()
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            const direction = event.key === "ArrowUp" ? 5 : -5
            setImagePositionY((currentPosition) => Math.min(100, Math.max(0, currentPosition + direction)))
        } else {
            const direction = event.key === "ArrowLeft" ? 5 : -5
            setImagePositionX((currentPosition) => Math.min(100, Math.max(0, currentPosition + direction)))
        }
    }

    const onSubmit = (event: { preventDefault: () => void }) => {
        event.preventDefault()
        if (!validateForm()) {
            return
        }

        let formData = new FormData()

        setIsSubmitting(true)

        if (role === RoleType.ORGANIZATION && orgId) {
            formData.append("content_type", "organization")
            formData.append("object_id", orgId)
        } else if (role === RoleType.USER) {
            formData.append("content_type", "user")
        }

        formData.append("room", roomDataState.id.toString());
        formData.append("room_id", roomDataState.id.toString());
        formData.append("title", name)
        formData.append("description", description)
        const selectedFormat = formats.find((format) => format.id === formatId);
        formData.append("formats", selectedFormat ? selectedFormat.name : "");
        formData.append("admission", admission)
        formData.append("registration_link", registrationLink)
        const selectedLocationType = locationTypes.find((locationType) => locationType.id === locationTypeId);
        formData.append("location_type", selectedLocationType ? selectedLocationType.name : "");
        formData.append("location_details", locationDetails)
        formData.append("access_link", accessLink)
        formData.append("mail", mail)
        formData.append("website", website)
        formData.append("keywords", JSON.stringify(keywords))
        formData.append("start_date", formatLocalDateTimeForApi(beginDate))
        formData.append("end_date", formatLocalDateTimeForApi(endDate))
        formData.append("image_position_x", imagePositionX.toString())
        formData.append("image_position_y", imagePositionY.toString())

        if (file) {
            formData.append("image", file)
        }

        if (props.createEvent) {
            setIsSubmitting(true)
            createEventRequest(roomId, formData).then((response) => {
                if (response.status === 201) {
                    if (sendNotification) {

                        if (notificationText.includes("#EID#")) {
                            let notificationTextWithLink = notificationText.replace("#EID#", response.data.id)
                            editorRef2.current?.setContent(notificationTextWithLink)
                        }
                        const formData = new FormData()

                        const objectId = (role === RoleType.ORGANIZATION ? orgId : userDataState.id)

                        formData.append("content", editorRef2.current!.getContent({ format: 'raw' }))
                        formData.append("content_type", role.toLowerCase())
                        formData.append("object_id", objectId?.toString()!)
                        formData.append("tags", JSON.stringify([]))
                        formData.append("room", roomId.toString())

                        dispatch<any>(roomPostPostRequest(formData, posts))
                    }

                    setIsSubmitting(false)
                    dispatch(setRoomEventsData({
                        ...roomEventsState,
                        items: [...roomEventsState.items, response.data].sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime()),
                        selectedItem: response.data,
                        stats: { ...roomEventsState.stats, total_items: roomEventsState.stats.total_items + 1 }
                    }))
                    dispatch(setRoomData({
                        ...roomDataState,
                        total_events: (roomDataState.total_events ?? 0) + 1
                    }))
                    dispatch(setModalData({ open: false, roomCreateEventModal: {} }))

                }
            }).catch((error) => {
                const statusCode = error?.response?.status;

                if (statusCode === 400) {
                    const errors = error?.response?.data || {};

                    if (errors.title) {
                        setNameError(errors.title[0]);
                    }
                    if (errors.start_date) {
                        setStartDateError(errors.start_date[0]);
                    }
                    if (errors.end_date) {
                        setEndDateError(errors.end_date[0]);
                    }
                    if (errors.keywords) {
                        setKeywordsError(errors.keywords[0]);
                    }
                    if (errors.admission) {
                        setAdmissionError(errors.admission[0]);
                    }
                    if (errors.registration_link) {
                        setRegistrationLinkError(errors.registration_link[0]);
                    }
                    if (errors.mail) {
                        setMailError(errors.mail[0]);
                    }
                    if (errors.website) {
                        setWebsiteError(errors.website[0]);
                    }
                    if (errors.formats) {
                        setFormatError(errors.formats[0]);
                    }
                    if (errors.location_type) {
                        setLocationTypeError(errors.location_type[0]);
                    }
                    if (errors.access_link) {
                        setAccessLinkError(errors.access_link[0]);
                    }
                    if (errors.non_field_errors?.[0]) {
                        setServerError(errors.non_field_errors[0]);
                    } else if (errors.detail) {
                        setServerError(Array.isArray(errors.detail) ? errors.detail[0] : errors.detail);
                    } else {
                        setServerError("Bitte die markierten Felder überprüfen.")
                    }
                } else if (statusCode === 403) {
                    setServerError(getApiErrorMessage(error));
                } else {
                    setServerError(getApiErrorMessage(error));
                }
                console.log(error)
            }).finally(() => {
                setIsSubmitting(false)
            })
        } else if (props.editEvent) {
            updateEventRequest(roomId, roomEventsState.selectedItem!.id, formData).then((response) => {
                if (response.status === 200) {
                    setIsSubmitting(false)
                    dispatch(setRoomEventsData({
                        ...roomEventsState,
                        items: roomEventsState.items
                            .map(item => item.id === response.data.id ? response.data : item)
                            .sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime()),
                        selectedItem: response.data
                    }))
                    dispatch(setModalData({ open: false, roomCreateEventModal: {} }))

                }
            }).catch((error) => {
                const statusCode = error?.response?.status;

                if (statusCode === 400) {
                    const errors = error?.response?.data || {};

                    if (errors.title) {
                        setNameError(errors.title[0]);
                    }
                    if (errors.start_date) {
                        setStartDateError(errors.start_date[0]);
                    }
                    if (errors.end_date) {
                        setEndDateError(errors.end_date[0]);
                    }
                    if (errors.keywords) {
                        setKeywordsError(errors.keywords[0]);
                    }
                    if (errors.admission) {
                        setAdmissionError(errors.admission[0]);
                    }
                    if (errors.registration_link) {
                        setRegistrationLinkError(errors.registration_link[0]);
                    }
                    if (errors.mail) {
                        setMailError(errors.mail[0]);
                    }
                    if (errors.website) {
                        setWebsiteError(errors.website[0]);
                    }
                    if (errors.format) {
                        setFormatError(errors.format[0]);
                    }
                    if (errors.location_type) {
                        setLocationTypeError(errors.location_type[0]);
                    }
                    if (errors.access_link) {
                        setAccessLinkError(errors.access_link[0]);
                    }
                    if (errors.non_field_errors?.[0]) {
                        setServerError(errors.non_field_errors[0]);
                    } else if (errors.detail) {
                        setServerError(Array.isArray(errors.detail) ? errors.detail[0] : errors.detail);
                    } else {
                        setServerError("Bitte die markierten Felder überprüfen.")
                    }
                } else if (statusCode === 403) {
                    setServerError(getApiErrorMessage(error));
                } else {
                    setServerError(getApiErrorMessage(error));
                }
                console.log(error)
            }).finally(() => {
                setIsSubmitting(false)
            })
        }
    }

    const onModalClose = () => {
        dispatch(setModalData({ open: false, roomUploadModal: false }))
    }

    // removed unused org admin fetch

    return (
        <div className="event-modal">
            <div className="event-modal__content">
                <div className="event-modal__upper-panel">
                    <div className="event-modal__title">{props.createEvent ? translation.create_event : translation.edit_event}</div>
                    <div onClick={onModalClose} className="event-modal__close-icon">
                        <CloseIcon />
                    </div>
                </div>
                <div className="event-modal__divider"></div>
                <div className="event-modal__wizard-progress" aria-label={`Schritt ${currentStep + 1} von ${totalSteps}`}>
                    {stepTitles.map((stepTitle, index) => (
                        <div
                            key={stepTitle}
                            className={`event-modal__wizard-step ${index === currentStep ? "event-modal__wizard-step--active" : ""} ${index < currentStep ? "event-modal__wizard-step--complete" : ""}`}
                        >
                            <span className="event-modal__wizard-step-number">{index + 1}</span>
                            <span className="event-modal__wizard-step-label">{stepTitle}</span>
                        </div>
                    ))}
                </div>
                <div className="event-modal__middle-panel">
                    { /* Wizard step state */}
                    <div className="event-modal__step-content">
                        <div className="event-modal__step-heading">
                            <span>Schritt {currentStep + 1} von {totalSteps}</span>
                            <h2>{stepTitles[currentStep]}</h2>
                        </div>
                        {
                            (
                                <>
                                    {currentStep === 0 && (
                                        <>
                                            <SingleTextInput
                                                textInput={<TextInput
                                                    className="room-events__single-text-input"
                                                    type="text"
                                                    value={name}
                                                    textinputsize="small-40"
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        setName(event.target.value)
                                                        setNameError("")
                                                        setServerError("")
                                                    }}
                                                    placeholder={translation.name}
                                                    name="name"
                                                    autoComplete="off"
                                                    maxLength={100}
                                                />}
                                                errorText={nameError}
                                                title={translation.name}
                                            />

                                            <div className="event-modal__about-container">
                                                <div className="event-modal__max-character-container">
                                                    <div className="event-modal__text-area">
                                                        <div className="single-text-input__text">
                                                            {translation.description}
                                                        </div>
                                                        <EditorTextArea
                                                            key={`description-editor`}
                                                            inputState={description}
                                                            setInputState={setDescription}
                                                            editorRef={editorRef}
                                                            editorPlaceholder={translation.description}
                                                            editorHeight={150}
                                                            modifier={EditorModifier.editRoomDescription}
                                                            initialEditorValue={description}
                                                            setContent={() => { }}
                                                            enterPressed={() => { }}
                                                        />
                                                    </div>

                                                    <CharacterCounter current={textWithoutHtml.length} max={1000} modifier="" />
                                                    <p className="event-modal__error-text">{descriptionError}</p>
                                                </div>
                                            </div>

                                            <div className="event-modal__dropdown-field">
                                                <Dropdown
                                                    itemId={formatId}
                                                    setItemId={(value: number) => {
                                                        setFormatId(value)
                                                        setFormatError("")
                                                        setServerError("")
                                                    }}
                                                    items={formats}
                                                    placeholder={translation.chooseFormat}
                                                    tabIndex={formats[0].id}
                                                    selectModifier="dropdown__select--unset-width"
                                                    dropdownModifier="dropdown--unset-width"
                                                />
                                                <p className="accordion__error-message">{formatError}</p>
                                            </div>

                                            <SingleTextInput
                                                textInput={<HashtagInput hashtags={keywords} setHashtags={setKeywords} />}
                                                title={translation.hashtags}
                                                errorText={keywordsError}
                                            />
                                        </>
                                    )}
                                    {currentStep === 1 && (
                                        <>
                                            <h3 className="event-modal__section-title">Zeitpunkt</h3>
                                            <div className="event-modal__field-grid">
                                                <div className="room-events__date-input-container">
                                                <SingleTextInput
                                                    textInput={<TextInput
                                                        className="room-events__date-input"
                                                        type="datetime-local"
                                                        value={beginDate ? `${beginDate.getFullYear()}-${String(beginDate.getMonth() + 1).padStart(2, '0')}-${String(beginDate.getDate()).padStart(2, '0')}T${String(beginDate.getHours()).padStart(2, '0')}:${String(beginDate.getMinutes()).padStart(2, '0')}` : ""}
                                                        textinputsize="small-40"
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            const selectedStartDate = event.target.value ? new Date(event.target.value) : null
                                                            setStartDateError("")
                                                            setServerError("")
                                                            setBeginDate(selectedStartDate)

                                                            if (!endDate && selectedStartDate) {
                                                                const suggestedEndDate = new Date(selectedStartDate.getTime() + 60 * 60 * 1000)
                                                                setEndDate(suggestedEndDate)
                                                                setEndDateError("")
                                                            }
                                                        }}
                                                        placeholder={translation.eventDate}
                                                        name="beginDate"
                                                        autoComplete="off"
                                                    />}
                                                    errorText={startDateError}
                                                    title={translation.eventStart}
                                                />
                                                </div>
                                                <div className="room-events__date-input-container">

                                                <SingleTextInput
                                                    textInput={<TextInput
                                                        className="room-events__date-input"
                                                        type="datetime-local"
                                                        value={endDate ? `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}T${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}` : ""}
                                                        textinputsize="small-40"
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            const selectedEndDate = event.target.value ? new Date(event.target.value) : null;
                                                            setEndDate(selectedEndDate);

                                                            if (selectedEndDate && beginDate && selectedEndDate <= beginDate) {
                                                                setEndDateError("Das Ende deiner Veranstaltung kann nicht vor dem Anfang liegen.");
                                                            } else {
                                                                setEndDateError("");
                                                            }

                                                            setServerError("")
                                                        }}
                                                        placeholder={translation.eventDate}
                                                        name="endDate"
                                                        autoComplete="off"
                                                    />}
                                                    errorText={endDateError}
                                                    title={translation.eventEnd}
                                                />
                                                </div>
                                            </div>

                                            <h3 className="event-modal__section-title">Ort</h3>
                                            <div className="event-modal__dropdown-field">
                                                <Dropdown
                                                    itemId={locationTypeId}
                                                    setItemId={(value: number) => {
                                                        setLocationTypeId(value)
                                                        setLocationTypeError("")
                                                        setRegistrationLinkError("")
                                                        setAccessLinkError("")
                                                        setLocationDetailsError("")
                                                        setServerError("")
                                                    }}
                                                    items={locationTypes}
                                                    placeholder={translation.chooseLocationType}
                                                    tabIndex={locationTypes[0].id}
                                                    selectModifier="dropdown__select--unset-width"
                                                    dropdownModifier="dropdown--unset-width"
                                                />
                                                <p className="accordion__error-message">{locationTypeError}</p>
                                            </div>

                                            <div className="event-modal__field-grid">
                                                {(locationTypeId === 1 || locationTypeId === 2) && (
                                                    <SingleTextInput
                                                        textInput={<TextInput
                                                            className="room-events__single-text-input"
                                                            type="text"
                                                            value={accessLink}
                                                            textinputsize="small-40"
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                setAccessLink(event.target.value)
                                                                setAccessLinkError("")
                                                                setServerError("")
                                                            }}
                                                            placeholder={translation.accessLink}
                                                            name="accessLink"
                                                            autoComplete="off"
                                                            maxLength={100}
                                                        />}
                                                        errorText={accessLinkError}
                                                        title={translation.accessLink}
                                                    />
                                                )}

                                                {(locationTypeId === 2 || locationTypeId === 3) && (
                                                    <SingleTextInput
                                                        textInput={<TextInput
                                                            className="room-events__single-text-input"
                                                            type="text"
                                                            value={locationDetails}
                                                            textinputsize="small-40"
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                setLocationDetails(event.target.value)
                                                                setLocationDetailsError("")
                                                                setServerError("")
                                                            }}
                                                            placeholder={translation.locationDetails}
                                                            name="locationDetails"
                                                            autoComplete="off"
                                                            maxLength={100}
                                                        />}
                                                        errorText={locationDetailsError}
                                                        title={translation.locationDetails}
                                                    />
                                                )}
                                            </div>

                                            <h3 className="event-modal__section-title">Teilnahme</h3>
                                            <div className="event-modal__field-grid">
                                                <SingleTextInput
                                                    textInput={<TextInput
                                                        className="room-events__single-text-input"
                                                        type="text"
                                                        value={admission}
                                                        textinputsize="small-40"
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            setAdmission(event.target.value)
                                                            setAdmissionError("")
                                                            setServerError("")
                                                        }}
                                                        placeholder={translation.admission}
                                                        name="admission"
                                                        autoComplete="off"
                                                        maxLength={100}
                                                    />}
                                                    title={translation.admission + " " + translation.optional}
                                                    errorText={admissionError}
                                                />

                                                <SingleTextInput
                                                    textInput={<TextInput
                                                        className="room-events__single-text-input"
                                                        type="text"
                                                        value={registrationLink}
                                                        textinputsize="small-40"
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            setRegistrationLink(event.target.value)
                                                            setRegistrationLinkError("")
                                                            setServerError("")
                                                        }}
                                                        placeholder={translation.registrationLink}
                                                        name="registrationLink"
                                                        autoComplete="off"
                                                        maxLength={100}
                                                    />}
                                                    title={translation.registrationLink + " " + translation.optional}
                                                    errorText={registrationLinkError}
                                                />
                                            </div>
                                        </>
                                    )}
                                    {currentStep === 2 && (
                                        <>
                                            <section className="event-modal__section">
                                                <h3 className="event-modal__section-title">Titelbild <span>{translation.optional}</span></h3>
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    className="hidden"
                                                    accept="image/*"
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        if (event.target.files && event.target.files.length > 0) {
                                                            selectImage(event.target.files[0])
                                                        }
                                                    }}
                                                />
                                                {!imagePreviewUrl && (
                                                    <div
                                                        className="room-upload-modal__file-upload room-events__image-upload"
                                                        onClick={() => document.getElementById("file-upload")?.click()}
                                                        onDrop={(event) => {
                                                            event.preventDefault()
                                                            if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
                                                                selectImage(event.dataTransfer.files[0])
                                                            }
                                                        }}
                                                        onDragOver={(event) => event.preventDefault()}
                                                    >
                                                        <label htmlFor="file-upload" className="room-upload-modal__file-upload-label">
                                                            {translation.dragAndDropFile}
                                                        </label>
                                                    </div>
                                                )}
                                                {imagePreviewUrl && (
                                                    <div className="room-events__image-editor">
                                                        <div className="room-events__image-position-control">
                                                            <div
                                                                ref={imagePositionPreviewRef}
                                                                className={`room-events__image-position-preview ${isPositioningImage ? "room-events__image-position-preview--dragging" : ""}`}
                                                                role="group"
                                                                tabIndex={0}
                                                                aria-label="Bildausschnitt verschieben"
                                                                onPointerDown={onImagePositionPointerDown}
                                                                onPointerMove={onImagePositionPointerMove}
                                                                onPointerUp={stopImagePositioning}
                                                                onPointerCancel={stopImagePositioning}
                                                                onKeyDown={onImagePositionKeyDown}
                                                            >
                                                                <Image
                                                                    src={imagePreviewUrl}
                                                                    alt="Titelbild-Vorschau"
                                                                    style={{ objectPosition: `${imagePositionX}% ${imagePositionY}%` }}
                                                                />
                                                                <span className="room-events__image-position-grid" aria-hidden="true" />
                                                                <span className="room-events__image-position-handle" aria-hidden="true">
                                                                    <span>↔</span>
                                                                    <span>↕</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="room-events__image-actions">
                                                            <button type="button" onClick={() => document.getElementById("file-upload")?.click()}>Ersetzen</button>
                                                            <button type="button" onClick={() => { setImagePositionX(50); setImagePositionY(50) }}>Zentrieren</button>
                                                            {fileselected && (
                                                                <button
                                                                    type="button"
                                                                    className="room-events__image-action--danger"
                                                                    onClick={() => {
                                                                        setFileSelected(false)
                                                                        setFile(null)
                                                                        setImagePreviewUrl(props.editEvent ? roomEventsState.selectedItem?.image || "" : "")
                                                                        setServerError("")
                                                                    }}
                                                                >
                                                                    Entfernen
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </section>

                                            <h3 className="event-modal__section-title">Kontakt</h3>
                                            <div className="event-modal__field-grid">
                                                <SingleTextInput
                                                textInput={<TextInput
                                                    className="room-events__single-text-input"
                                                    type="text"
                                                    value={mail}
                                                    textinputsize="small-40"
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        setMail(event.target.value)
                                                        setMailError("")
                                                        setServerError("")
                                                    }}
                                                    placeholder={translation.mail}
                                                    name="mail"
                                                    autoComplete="off"
                                                    maxLength={100}
                                                />}
                                                title={translation.mail + " " + translation.optional}
                                                errorText={mailError}
                                            />

                                            <SingleTextInput
                                                textInput={<TextInput
                                                    className="room-events__single-text-input"
                                                    type="text"
                                                    value={website}
                                                    textinputsize="small-40"
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        setWebsite(event.target.value)
                                                        setWebsiteError("")
                                                        setServerError("")
                                                    }}
                                                    placeholder={translation.website}
                                                    name="website"
                                                    autoComplete="off"
                                                    maxLength={100}
                                                />}
                                                title={translation.website + " " + translation.optional}
                                                errorText={websiteError}
                                            />
                                            </div>

                                            {props.createEvent && (
                                                <>
                                                <h3 className="event-modal__section-title">Veröffentlichung</h3>
                                                <div className="event-modal__checkbox-container">
                                                    <Checkbox color="dark-blue"
                                                        checked={sendNotification} onChange={() => setSendNotification(!sendNotification)}
                                                    />
                                                    <div className="create-room-modal__text create-room-modal__text--margin-left-1">
                                                        Raumbenachrichtung erstellen
                                                    </div>
                                                </div>
                                                </>
                                            )}


                                            <div className={`event-modal__about-container ${!sendNotification ? 'hidden' : ''}`}>
                                                <div className="event-modal__max-character-container">
                                                    <div className="event-modal__text-area">
                                                        <EditorTextArea
                                                            inputState={notificationText}
                                                            setInputState={setNotificationText}
                                                            editorRef={editorRef2}
                                                            editorPlaceholder={notificationText}
                                                            editorHeight={98}
                                                            modifier={EditorModifier.editRoomDescription}
                                                            initialEditorValue={''}
                                                            setContent={() => { }}
                                                            enterPressed={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )
                        }
                    </div>

                    {serverError && <p className="event-modal__form-error" role="alert">{serverError}</p>}
                    <div className="event-modal__wizard-footer">
                        <div className="event-modal__wizard-footer-left">
                            {currentStep > 0 && (
                                <Button
                                    onClick={goBack}
                                    type="button"
                                    className="button button--padding-small button--font-size-small button--font-weight-400 button--color-grey button--hover-brighter button--cursor-pointer button--border-radius-05 "
                                >
                                    {translation.back ?? 'Zurück'}
                                </Button>
                            )}
                        </div>
                        <div className="event-modal__wizard-footer-right">
                            {currentStep < totalSteps - 1 ? (
                                <Button
                                    onClick={goNext}
                                    type="button"
                                    className="button button--padding-small button--font-size-small button--font-weight-400 button--text-color-white  button--color-gold  button--hover-brighter button--cursor-pointer button--border-radius-05 "
                                    disabled={isSubmitting}
                                >
                                    {translation.next ?? 'Weiter'}
                                </Button>
                            ) : (
                                <Button
                                    onClick={onSubmit}
                                    type="submit"
                                    className="button button--padding-small button--border-radius-05 button--color-gold button--hover-brighter button--cursor-pointer button--text-color-white button--font-size-small button--font-weight-400 "
                                    disabled={isSubmitting}
                                >
                                    {props.createEvent ? translation.create_event : translation.save}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default RoomCreateEventModal
